import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import he from 'date-fns/locale/he';
import './DatePicker.scss';
import {parse} from 'date-fns';
import {getFormatDate} from '../../../utilities/dateUtils';
import arrowIcon from './arrow.svg';
import { isMobile } from 'react-device-detect';
const DatePickerComponent = ({ selectedDate, setSelectedDate ,ref ,dependedDate ,numOfYearsBack =1 ,maxDate = null , title = null ,placeholder = null ,inputWidth = 140 ,inputHeight = 40 }) => {
     
    const toDate = (val) => {
      if (val instanceof Date) return val;
      try {
        if (typeof val === 'string' && val.includes('T')) {
          return new Date(val);
        }
        return parse(val, 'dd/MM/yyyy', new Date());
      } catch {
        return null;
      }
    };
  const [isOpen, setIsOpen] = useState(false);

  const handleInputClick = () => {
    if (isOpen) return;
    setIsOpen(true);
  };


  

  const handleDateChange = (date, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setSelectedDate(getFormatDate(date));
    setIsOpen(false);
  };

  const CustomInput = React.forwardRef(() => (
    <div className="custom-date-input-wrapper">

      <input
        ref={ref}
        value={selectedDate || ''}
        placeholder={placeholder}
        readOnly
        className="custom-date-input"
        style={{ width: inputWidth, height: inputHeight }}
      />    
      
    <Image height={24}
        width={24}
        src={require('./calendar.svg')} 
        alt="calendar" 
        className="calendar-icon" />
    </div>
  ));

  return (
    <div className='datepicker-container' onClick={handleInputClick}>
      <DatePicker
        customInput={<CustomInput />}
        selected={selectedDate ? toDate(selectedDate) : null}
        onChange={handleDateChange}
        locale={he}
        dateFormat='dd/MM/yyyy'
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={numOfYearsBack}
        minDate={dependedDate ? toDate(dependedDate) : null}
        maxDate={maxDate ? toDate(maxDate) : null}
        calendarStartDay={0}
        ref={ref}
        open={isOpen}
        onClickOutside={() => setIsOpen(false)}
        previousMonthButtonLabel={<Image className='arrow-right' src={arrowIcon} alt="arrow-right" />}
        nextMonthButtonLabel={<Image className='arrow-left' src={arrowIcon} alt="arrow-left" />}
        renderCustomHeader={({
          date,
          changeYear,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled
        }) => (
    <div className='custom-datepicker-header'>
      { title && (
        <span className='title'>{title}</span>
      )}
      <div className='date-header'>
      <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ background: "none", border: "none" ,outline: "none" , 
        cursor: prevMonthButtonDisabled ? 'not-allowed' : 'pointer'
      }}>
        <Image className='arrow-right' src={arrowIcon} alt="arrow-right" />
      </button>
      <span>
        {date.toLocaleString('he', { month: 'long' })}{" "}
        {numOfYearsBack > 1 ? (
          <select
            value={date.getFullYear()}
            onChange={({ target: { value } }) => changeYear(Number(value))}
          >
            {Array.from({ length: numOfYearsBack}, (_, i) => {
              const year = new Date().getFullYear() - i;
              return <option key={year} value={year}>{year}</option>;
            })}
          </select>
        ) : ( 
          <span>{date.getFullYear()}</span>
        )}
      </span>
      
      <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ background: "none", border: "none", 
        cursor: nextMonthButtonDisabled ? 'not-allowed' : 'pointer'
      }}>
        <Image className='arrow-left' src={arrowIcon} alt="arrow-left" />
      </button>
        </div>
        </div>
      )}
    />
  </div>
  );
};

const mapStateToProps = (state) => ({
  businessWorkOrderSystem: state.businessWorkOrderSystem,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(DatePickerComponent);
